import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconKonfigurimet = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	width: 24,
	height: 24,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M0 0h24v24H0z",
		fill: "none"
	}), /* @__PURE__ */ _jsx("path", { d: "M20.63 14.58A7.927 7.927 0 0 0 22 12c0-4.42-3.58-8-8-8s-8 3.58-8 8 3.58 8 8 8c1.3 0 2.52-.31 3.58-.85l3.81 3.81a.5.5 0 0 0 .71 0l1.41-1.41a.5.5 0 0 0 0-.71zM4 12c0-3.31 2.69-6 6-6s6 2.69 6 6-2.69 6-6 6-6-2.69-6-6zm9-2h-2V8h2v2zm-5 0H6V8h2v2zm0-3H6V5h2v2zm5 0h-2V5h2v2z" })]
});
export { SvgIconKonfigurimet as ReactComponent };
